import { Routes } from '@angular/router'
import { isAuthenticated } from '../../core/auth/guards/auth.guard'

export const superAdminRoutes: Routes = [
	{
		path: 'super-admin',
		canActivate: [isAuthenticated],
		loadComponent: () => import('../../layout/main-layout/main-layout'),
		data: {
			role: 'SUPER_ADMIN',
			title: 'Super Admin Dashboard',
			breadcrumb: 'SuperAdmin',
			preload: true,
			roles: ['SUPER_ADMIN'],
		},
		children: [
			// Elasticsearch Management
			{
				path: 'admin-dashboard',
				loadComponent: () => import('./admin-dashboard/admin-dashboard'),
				data: {
					title: 'داشبورد مدیریت',
					breadcrumb: 'داشبورد مدیریت',
					icon: 'admin-dashboard',
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				path: 'elastic-management',
				loadComponent: () => import('./elastic-management/elastic-management'),
				data: {
					title: 'Elasticsearch Management',
					breadcrumb: 'Elasticsearch',
					icon: 'database',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},

			// Admin Dashboard
			{
				path: 'space-type',
				loadComponent: () => import('./space-type/space-type.component'),
				data: {
					title: 'Admin Dashboard',
					breadcrumb: 'Dashboard',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},

			// User Management
			{
				path: 'users-management',
				children: [
					{
						path: '',
						loadComponent: () => import('./user-management/user-management'),
						data: {
							title: 'Users Management',
							breadcrumb: 'Users',
							icon: 'users',
							preload: true,
							roles: ['ADMIN'],
						},
					},
					{
						path: 'add',
						loadComponent: () => import('./user-management/add-user/add-user'),
						data: {
							title: 'Add User',
							breadcrumb: 'Add User',
						},
					},
					{
						path: 'edit/:id',
						loadComponent: () => import('./user-management/add-user/add-user'),
						data: {
							title: 'Edit User',
							breadcrumb: 'Edit User',
						},
					},
				],
			},
			{
				path: 'speciality-type',
				loadComponent: () => import('./speciality-type/speciality-type.component'),
				data: {
					title: 'Admin Dashboard',
					breadcrumb: 'Dashboard',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},

			{
				path: 'facility',
				loadComponent: () => import('./facility/facility.component'),
				data: {
					title: 'Admin Dashboard',
					breadcrumb: 'Dashboard',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				path: 'neighborhood',
				loadComponent: () => import('./neighborhood/neighborhood.component'),
				data: {
					title: 'Neighborhoods',
					breadcrumb: 'Neighborhoods',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				path: 'approval-list',
				loadComponent: () => import('./approval-wait-list/approval-wait-list.component'),
				data: {
					title: 'Admin Dashboard',
					breadcrumb: 'Dashboard',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				// Academy M7: generic app_setting editor (no hardcoded limits — PRD ch.32).
				path: 'app-settings',
				loadComponent: () => import('./app-settings/app-settings'),
				data: {
					title: 'تنظیمات عمومی',
					breadcrumb: 'تنظیمات عمومی',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				// Academy M5: reported-review moderation queue.
				path: 'review-moderation',
				loadComponent: () => import('./review-moderation/review-moderation'),
				data: {
					title: 'بررسی نظرات',
					breadcrumb: 'بررسی نظرات',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				// Academy M5: BeautyBoss Score weight settings.
				path: 'score-settings',
				loadComponent: () => import('./score-settings/score-settings'),
				data: {
					title: 'وزن‌های امتیاز',
					breadcrumb: 'وزن‌های امتیاز',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				// Academy M3: generic coupon management (all BeautyBoss services).
				path: 'coupon-management',
				loadComponent: () => import('./coupon-management/coupon-management'),
				data: {
					title: 'کدهای تخفیف',
					breadcrumb: 'کدهای تخفیف',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				// Academy M2: course moderation console (approve / reject / needs-revision).
				path: 'course-ads',
				loadComponent: () => import('./course-ads-admin/course-ads-admin'),
				data: {
					title: 'مدیریت دوره‌ها',
					breadcrumb: 'مدیریت دوره‌ها',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				// Academy M1: instructor professional-verification console.
				path: 'instructor-verification',
				loadComponent: () => import('./instructor-verification/instructor-verification'),
				data: {
					title: 'تأیید مدرسان',
					breadcrumb: 'تأیید مدرسان',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				// Marketplace M2: dictionary console — pending «سایر» values + brands/models (PRD فاز۲ فصل۶).
				path: 'marketplace-dict',
				loadComponent: () => import('./marketplace-dict/marketplace-dict'),
				data: {
					title: 'دیکشنری مارکت‌پلیس',
					breadcrumb: 'دیکشنری مارکت‌پلیس',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				// Marketplace M8: marketplace review moderation queue (hide/restore).
				path: 'marketplace-reviews',
				loadComponent: () => import('./marketplace-reviews/marketplace-reviews'),
				data: {
					title: 'نظرات مارکت‌پلیس',
					breadcrumb: 'نظرات مارکت‌پلیس',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				path: 'accept-ad',
				loadComponent: () => import('./accept-ad/accept-ad'),
				data: {
					title: 'Admin Dashboard',
					breadcrumb: 'Dashboard',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				path: 'banner-management',
				loadComponent: () => import('./banner-management/banner-management'),
				data: {
					title: 'مدیریت بنرها',
					breadcrumb: 'مدیریت بنرها',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				path: 'banner-report',
				loadComponent: () => import('./banner-report/banner-report'),
				data: {
					title: 'گزارشات بنر',
					breadcrumb: 'گزارشات بنر',
					icon: 'chart-bar',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				path: 'promotion-management',
				loadComponent: () => import('./promotion-management/promotion-management'),
				data: {
					title: 'Ad Report',
					breadcrumb: 'Ad Report',
					icon: 'chart-bar',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				path: 'ad-reports',
				loadComponent: () => import('./ad-reports/ad-reports'),
				data: {
					title: 'Ad Report',
					breadcrumb: 'Ad Report',
					icon: 'chart-bar',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				path: 'chat-reports',
				loadComponent: () => import('./chat-reports/chat-reports'),
				data: {
					title: 'Chat Reports',
					breadcrumb: 'گزارش\u200cهای گفتگو',
					icon: 'comments',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},
			{
				path: 'payment-reports',
				loadComponent: () => import('./payment-reports/payment-reports'),
				data: {
					title: 'Payment Reports',
					breadcrumb: 'گزارش\u200cمالی',
					icon: 'comments',
					preload: true,
					roles: ['SUPER_ADMIN'],
				},
			},

			// Base Information Management
			// {
			// 	path: 'goods-category',
			// 	loadComponent: () => import('./baseInformation/goods-category/goods-category'),
			// 	data: {
			// 		title: 'Goods Category',
			// 		breadcrumb: 'Goods Category',
			// 		icon: 'category',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			// {
			// 	path: 'stock-symbol',
			// 	children: [
			// 		{
			// 			path: '',
			// 			loadComponent: () => import('./baseInformation/stock-symbol/stock-symbol'),
			// 			data: {
			// 				title: 'Stock Symbols',
			// 				breadcrumb: 'Stock Symbols',
			// 				icon: 'stock',
			// 			},
			// 		},
			// 		{
			// 			path: 'add',
			// 			loadComponent: () => import('./baseInformation/stock-symbol/add-stock-symbol/add-stock-symbol'),
			// 			data: {
			// 				title: 'Add Stock Symbol',
			// 				breadcrumb: 'Add Stock',
			// 			},
			// 		},
			// 		{
			// 			path: 'edit/:id',
			// 			loadComponent: () => import('./baseInformation/stock-symbol/add-stock-symbol/add-stock-symbol'),
			// 			data: {
			// 				title: 'Edit Stock Symbol',
			// 				breadcrumb: 'Edit Stock',
			// 			},
			// 		},
			// 	],
			// },
			//
			// // Price Configuration
			// {
			// 	path: 'release-goods-from-warehouse-price-config',
			// 	loadComponent: () =>
			// 		import(
			// 			'./baseInformation/release-goods-from-warehouse-price-config/release-goods-from-warehouse-price-config'
			// 		),
			// 	data: {
			// 		title: 'Release Price Config',
			// 		breadcrumb: 'Release Price',
			// 		icon: 'price-config',
			// 	},
			// },
			// {
			// 	path: 'goods-to-warehousing-price-config',
			// 	loadComponent: () =>
			// 		import('./baseInformation/goods-to-warehousing-price-config/goods-to-warehousing-price-config'),
			// 	data: {
			// 		title: 'Warehousing Price Config',
			// 		breadcrumb: 'Warehousing Price',
			// 		icon: 'warehouse-price',
			// 	},
			// },
			// {
			// 	path: 'lab-analysis-price-config',
			// 	loadComponent: () => import('./baseInformation/lab-analysis-price-config/lab-analysis-price-config'),
			// 	data: {
			// 		title: 'Lab Analysis Price Config',
			// 		breadcrumb: 'Lab Analysis Price',
			// 		icon: 'lab-price',
			// 	},
			// },
			// {
			// 	path: 'legal-users-management',
			// 	loadComponent: () => import('./legal-users-management/legal-users-management'),
			// 	data: {
			// 		roles: ['ADMIN'],
			// 		preload: true,
			// 	},
			// },
			// // User Management
			// {
			// 	path: 'users-management',
			// 	children: [
			// 		{
			// 			path: '',
			// 			loadComponent: () => import('./user-management/user-management'),
			// 			data: {
			// 				title: 'Users Management',
			// 				breadcrumb: 'Users',
			// 				icon: 'users',
			// 				preload: true,
			// 				roles: ['ADMIN'],
			// 			},
			// 		},
			// 		{
			// 			path: 'add',
			// 			loadComponent: () => import('./user-management/add-user/add-user'),
			// 			data: {
			// 				title: 'Add User',
			// 				breadcrumb: 'Add User',
			// 			},
			// 		},
			// 		{
			// 			path: 'edit/:id',
			// 			loadComponent: () => import('./user-management/add-user/add-user'),
			// 			data: {
			// 				title: 'Edit User',
			// 				breadcrumb: 'Edit User',
			// 			},
			// 		},
			// 	],
			// },
			// {
			// 	path: 'money-request',
			// 	children: [
			// 		{
			// 			path: '',
			// 			loadComponent: () => import('./money-request/money-request'),
			// 			data: {
			// 				title: 'Users Management',
			// 				breadcrumb: 'Users',
			// 				icon: 'users',
			// 				preload: true,
			// 				roles: ['ADMIN'],
			// 			},
			// 		},
			// 	],
			// },
			// {
			// 	path: 'money-wallet-pay-by-id',
			// 	children: [
			// 		{
			// 			path: '',
			// 			loadComponent: () => import('./money-wallet-pay-by-id/money-wallet-pay-by-id'),
			// 			data: {
			// 				title: 'Users Management',
			// 				breadcrumb: 'Users',
			// 				icon: 'users',
			// 				preload: true,
			// 				roles: ['ADMIN'],
			// 			},
			// 		},
			// 	],
			// },
			//
			// // Reports
			// {
			// 	path: 'money-wallet',
			// 	loadComponent: () => import('./reports/admin/money-wallet/money-wallet'),
			// 	data: {
			// 		title: 'Money Wallet Report',
			// 		breadcrumb: 'Money Wallet',
			// 		icon: 'wallet-report',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			// {
			// 	path: 'trade',
			// 	loadComponent: () => import('./reports/admin/trade/trade'),
			// 	data: {
			// 		title: 'Trade Report',
			// 		breadcrumb: 'Trade Report',
			// 		icon: 'trade-report',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			// {
			// 	path: 'orders',
			// 	loadComponent: () => import('./reports/admin/orders/orders'),
			// 	data: {
			// 		title: 'Orders Report',
			// 		breadcrumb: 'Orders Report',
			// 		icon: 'orders-report',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			//
			// // Agreement Templates
			// {
			// 	path: 'agreement-templates',
			// 	loadComponent: () =>
			// 		import('./admin/agreement-templates/agreement-templates').then(m => m.AgreementTemplatesComponent),
			// 	data: {
			// 		title: 'Agreement Templates',
			// 		breadcrumb: 'Agreements',
			// 		icon: 'agreement',
			// 	},
			// },

			// Goods Management (shared with trading)
			// {
			// 	path: 'good-to-warehouse',
			// 	loadComponent: () => import('./goods-management/good-to-warehouse'),
			// 	data: {
			// 		title: 'Good to Warehouse',
			// 		breadcrumb: 'Good to Warehouse',
			// 		icon: 'goods-warehouse',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			// {
			// 	path: 'good-to-warehouse/goods-bundle-lab-analysis/:goodsToWarehouseId',
			// 	loadComponent: () => import('./goods-management/goods-bundle-lab-analysis-list/goods-bundle-lab-analysis-list'),
			// 	data: {
			// 		title: 'Lab Analysis',
			// 		breadcrumb: 'Lab Analysis',
			// 	},
			// },
			// User Profile
			{
				path: 'profile',
				loadComponent: () => import('../trading/profile/profile'),
				data: {
					title: 'Profile',
					breadcrumb: 'Profile',
					icon: 'user',
				},
			},
			// Default redirect
			{
				path: '',
				redirectTo: 'admin-dashboard',
				pathMatch: 'full',
			},
		],
	},
]
